<template>
  <tabs>
    <tab :name="props.tabName01">
      <slot name="tabContent01" />
    </tab>
    <tab :name="props.tabName02">
      <slot name="tabContent02" />
    </tab>
    <!-- <tab name="Disabled tab" :is-disabled="true"> -->
    <!--   <h2 class="page-subtitle">Disabled tab</h2> -->
    <!--   This content will be unavailable while :is-disabled prop set to true -->
    <!-- </tab> -->
    <!-- <tab id="oh-hi-mark" name="Custom fragment"> -->
    <!--   <h2 class="page-subtitle">Custom fragment</h2> -->
    <!--   The hash that is appended to the url can be customized. -->
    <!-- </tab> -->
    <!-- <tab prefix="<span class='prefix'>→</span>" name="Prefix and suffix" suffix="<span class='suffix'>4</span>"> -->
    <!--   <h2 class="page-subtitle">Prefix and suffix</h2> -->
    <!--   A prefix and a suffix can be added — HTML allowed. -->
    <!-- </tab> -->
    <!-- <tab nav-item-class="tabs-component-tab--custom" nav-item-link-class="tabs-component-tab-a--custom" name="Custom navigation item classes"> -->
    <!--   <h2 class="page-subtitle">Custom navigation item classes</h2> -->
    <!--   A custom nav-item-class & nav-item-link-class can be added to a tab's navigation item. -->
    <!-- </tab> -->
  </tabs>
</template>

<script setup>
import { Tab, Tabs } from 'vue3-tabs-component'
import { defineProps } from 'vue'

const props = defineProps({
    tabName01: {
        type: String,
        default: 'First tab A',
    },
    tabName02: {
        type: String,
        default: 'Second tab',
    },
})
</script>

<style>
.tabs-component {
  margin: 1em 0;
}

.tabs-component-tabs {
  border: solid 1px #ddd;
  border-radius: 6px;
  margin-bottom: 5px;
}

@media (min-width: 700px) {
  .tabs-component-tabs {
    border: 0;
    align-items: stretch;
    display: flex;
    justify-content: flex-start;
    margin-bottom: -1px;
  }
}

.tabs-component-tab,
.tabs-component-tab--custom {
  color: #999;
  font-size: 14px;
  font-weight: 600;
  margin-right: 0;
  list-style: none;
}

.tabs-component-tab:not(:last-child) {
  border-bottom: dotted 1px #ddd;
}

.tabs-component-tab:hover {
  color: #666;
}

.tabs-component-tab.is-active {
  color: #000;
}

.tabs-component-tab.is-disabled *,
.tabs-component-tab--custom.is-disabled * {
  color: #cdcdcd;
  cursor: not-allowed !important;
}

@media (min-width: 700px) {
  .tabs-component-tab,
  .tabs-component-tab--custom {
    background-color: #fff;
    border: solid 1px #ddd;
    border-radius: 3px 3px 0 0;
    margin-right: 0.5em;
    transform: translateY(2px);
    transition: transform 0.3s ease;
  }

  .tabs-component-tab.is-active,
  .tabs-component-tab--custom.is-active {
    border-bottom: solid 1px #fff;
    z-index: 2;
    transform: translateY(0);
  }
}

.tabs-component-tab-a,
.tabs-component-tab-a--custom {
  align-items: center;
  color: inherit;
  display: flex;
  padding: 0.75em 1em;
  text-decoration: none;
}

.tabs-component-panels {
  padding: 2em 0;
}

@media (min-width: 700px) {
  .tabs-component-panels {
    background-color: #fff;
    border: solid 1px #ddd;
    border-radius: 0 6px 6px 6px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.05);
    padding: 0;
    overflow: hidden;
    max-width: 48rem;
  }
}

.tabs-component-btn {
  cursor: pointer;
  background: #e1ecf4;
  border-radius: 3px;
  border: 1px solid #7aa7c7;
  padding: 4px 8px;
  color: #39739d;
}

.tabs-component-btn:hover {
  background-color: #b3d3ea;
  color: #2c5777;
}

.tabs-component-btn:active {
  background-color: #a0c7e4;
  box-shadow: none;
  color: #2c5777;
}

.tabs-component-tab--custom {
  border-color: #e1ecf4;
  color: #68838d;
}

.tabs-component-tab--custom:hover {
  border-color: #e1ecf4;
  color: #39739d;
}

.tabs-component-tab--custom.is-active {
  color: #39739d;
  border-color: #7aa7c7;
  border-bottom: solid 1px #fff;
}
</style>
